var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 19,
    viewBox: "0 0 35 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.4488C2.01328 13.5419 6.25896 11.4029 6.67947 11.2304C11.1599 9.39285 15.4238 9.26021 20.1911 9.26021C22.9839 9.26021 25.6239 9.90214 27.6596 7.86401C28.026 7.49721 28.5418 7.19817 27.5976 7.0263C25.8563 6.70931 24.152 5.91 22.6083 5.0406C21.3302 4.32084 20.1821 3.48089 19.0134 2.62053C18.7891 2.45538 17.38 2 18.0218 2C22.242 2 26.4697 5.68501 30.0458 7.58477C30.5915 7.87466 33.9431 8.84982 32.742 9.32226C31.4175 9.84321 30.2745 10.921 29.0852 11.6803C27.1356 12.925 25.5308 14.8573 23.5999 15.9619C23.1019 16.2469 22.1402 17.4759 21.8025 16.7997",
    stroke: "#DA494C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoForward);
export default __webpack_public_path__ + "static/media/video-forward.ee5adeb8b7c732be7fbd9d8d6f5354a8.svg";
export { ForwardRef as ReactComponent };